import React, { FC, ReactNode } from 'react';
import cx from 'classnames';

// Keep: LoginSuperAdmin / styleLoginV product illustration
import LoginVSvg from 'assets/image/login/login-image.png';

import styles from './Appeal.module.scss';

type AppealPropsType = {
	children?: ReactNode;
	styleCongrats?: boolean;
	styleJoin?: boolean;
	stylePensive?: boolean;
	styleThink?: boolean;
	styleLoginV?: boolean;
	styleContact?: boolean;
	styleTable?: boolean;
	isHeightDisable?: boolean;
	resetHeight?: boolean;
	isFullHeight?: boolean;
	withoutImage?: boolean;
};

/**
 * Appeal shell for modals/empty/success screens.
 * Legacy stock illustrations were removed; only `styleLoginV` still shows
 * `login-image.png` (approved keep). Style flags remain for call-site compatibility.
 */
const Appeal: FC<AppealPropsType> = ({
	children,
	styleCongrats,
	styleLoginV,
	styleTable,
	isHeightDisable,
	resetHeight,
	isFullHeight,
	withoutImage,
}: AppealPropsType) => {
	const showLoginImage = Boolean(styleLoginV) && !withoutImage;

	return (
		<div
			className={cx(styles.container, {
				[styles.congrats]: styleCongrats,
				[styles.styleTable]: styleTable,
				[styles.heightDisable]: isHeightDisable,
				[styles.paddingTopDisabled]: styleLoginV,
				[styles.resetHeight]: resetHeight,
				[styles.fullHeight]: isFullHeight,
				[styles.withoutImage]: !showLoginImage,
			})}
		>
			<div className={styles.container__gradient} />
			{showLoginImage ? <img src={LoginVSvg} className={styles.container__image_login} alt="" /> : null}
			{children}
		</div>
	);
};

export default Appeal;
